// Importing all directives
import './fileModel.directive'
import './focusMe.directive'
import './formception.directive'
import './nextFocus.directive'
import './ngConfirmClick.directive'
import './onModelChange.directive'
import './uppercased.directive'